import { codeOf } from './sendLabels';

const FILTER_ERROR_LABELS: Record<string, string> = {
  REACHED_FROM_INVALID: 'Reached from',
  REACHED_TO_INVALID: 'Reached to',
  STAGE_NOT_ALLOWED: 'Stage',
  INTENT_NOT_ALLOWED: 'Intent',
  LOCKED_RATE_INVALID: 'Locked rate',
};

/** The FilterPanel label of the param the rows route rejected, or null when the failure is not a filter. */
export function invalidFilterLabel(error: unknown): string | null {
  const code = codeOf(error);
  return code ? (FILTER_ERROR_LABELS[code] ?? null) : null;
}
